import React, { useMemo, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import ChartLegend from './ChartLegend';
import { aggregatePieData, CHART_COLORS, getSeriesKeys, hasSeries } from './chartUtils';

function colorForSeries(seriesKey, index) {
  return CHART_COLORS[index % CHART_COLORS.length];
}

export default function PieChartWidget({ rows, loading }) {
  var rowsWithSeries = hasSeries(rows || []);
  var seriesKeys = useMemo(function () {
    return rowsWithSeries ? getSeriesKeys(rows || []) : ['value'];
  }, [rows, rowsWithSeries]);

  var [isolatedSeries, setIsolatedSeries] = useState(null);
  var pieData = useMemo(function () {
    if (!rowsWithSeries) {
      return aggregatePieData(rows || [], null);
    }

    return aggregatePieData(rows || [], isolatedSeries);
  }, [rows, rowsWithSeries, isolatedSeries]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!pieData.length) {
    return <div className="re-widget-empty">No rows</div>;
  }

  return (
    <div className="re-chart-wrap">
      {rowsWithSeries ? (
        <ChartLegend
          seriesKeys={seriesKeys}
          isolatedSeries={isolatedSeries}
          onToggleSeries={function onToggleSeries(seriesKey) {
            setIsolatedSeries(function (previous) {
              return previous === seriesKey ? null : seriesKey;
            });
          }}
          colorForSeries={colorForSeries}
        />
      ) : null}

      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie data={pieData} dataKey="value" nameKey="name" outerRadius={95}>
            {pieData.map(function (entry, index) {
              return <Cell key={entry.name} fill={CHART_COLORS[index % CHART_COLORS.length]} />;
            })}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
